export const IconUpload = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.6666 42.6667L31.9999 32L21.3333 42.6667"
      stroke="#707070"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 32V56"
      stroke="#818181"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.3732 49.04C56.9741 47.6221 59.0288 45.3784 60.2129 42.663C61.397 39.9477 61.6431 36.9153 60.9124 34.0445C60.1818 31.1738 58.5159 28.6281 56.1777 26.8092C53.8395 24.9904 50.9622 24.002 47.9999 24H44.6399C43.8327 20.878 42.3283 17.9796 40.2398 15.5227C38.1512 13.0658 35.5328 11.1143 32.5815 9.81499C29.6302 8.51568 26.4227 7.90233 23.2002 8.02106C19.9777 8.13979 16.8241 8.98751 13.9764 10.5005C11.1287 12.0135 8.66099 14.1523 6.75889 16.7563C4.85678 19.3602 3.56973 22.3615 2.99451 25.5344C2.41928 28.7074 2.57084 31.9694 3.4378 35.0754C4.30475 38.1813 5.86454 41.0503 7.9999 43.4667"
      stroke="#818181"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.6666 42.6667L31.9999 32L21.3333 42.6667"
      stroke="#818181"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
